













import moment from 'moment';
import {
  Emit, Prop, Vue, Component,
} from '@samclick-commons';

    enum SamclickDateRangePickerType {
        MONTH_RANGE = 'monthrange',
        DATE_RANGE = 'daterange',
    }

    @Component
export class SamclickDateRangePicker extends Vue {
        @Prop({ default: '' }) private value!: string;

        defaultAttributes = new Map(
          [
            [SamclickDateRangePickerType.MONTH_RANGE, {
              format: 'MM-yyyy',
              'value-format': 'MM-yyyy',
              type: 'monthrange',
              'start-placeholder': 'Start month',
              'end-placeholder': 'End month',
            }],
            [SamclickDateRangePickerType.DATE_RANGE, {
              'value-format': 'yyyy-MM-dd[T]HH:mm:ss.SSS[Z]',
              type: SamclickDateRangePickerType.DATE_RANGE,
              'start-placeholder': 'Start date',
              'end-placeholder': 'End date',
            }],
          ],
        )

        defaultpickerOptions = new Map(
          [
            [SamclickDateRangePickerType.MONTH_RANGE, {
              shortcuts: [{
                text: 'This month',
                onClick(picker: any) {
                  const start = moment().startOf('month');
                  picker.$emit('pick', [start.toDate(), new Date()]);
                },
              }, {
                text: 'Last month',
                onClick(picker: any) {
                  const start = moment().subtract(1, 'months').startOf('month');
                  const end = moment().subtract(1, 'months').endOf('month');
                  picker.$emit('pick', [start.toDate(), end.toDate()]);
                },
              }, {
                text: 'Year-to-date',
                onClick(picker: any) {
                  const end = new Date();
                  const start = new Date(new Date().getFullYear(), 0);
                  picker.$emit('pick', [start, end]);
                },
              }, {
                text: 'Last 6 months',
                onClick(picker: any) {
                  const end = new Date();
                  const start = moment().subtract(6, 'months').startOf('month');
                  picker.$emit('pick', [start.toDate(), end]);
                },
              }],
            }],
            [SamclickDateRangePickerType.DATE_RANGE, {
              shortcuts: [{
                text: 'Last week',
                onClick(picker: any) {
                  const end = moment();
                  end.set({
                    hour: 23, minute: 59, second: 59, millisecond: 0,
                  });
                  end.toISOString();
                  end.format();
                  const start = moment().subtract(7, 'days');
                  start.set({
                    hour: 0, minute: 0, second: 0, millisecond: 0,
                  });
                  start.toISOString();
                  start.format();
                  picker.$emit('pick', [start.toDate(), end.toDate()]);
                },
              }, {
                text: 'Last month',
                onClick(picker: any) {
                  const start = moment().subtract(1, 'months').startOf('month');
                  const end = moment().subtract(1, 'months').endOf('month');
                  end.set({
                    hour: 23, minute: 59, second: 59, millisecond: 0,
                  });
                  picker.$emit('pick', [start.toDate(), end.toDate()]);
                },
              }, {
                text: 'Last 3 months',
                onClick(picker: any) {
                  const start = moment().subtract(3, 'months').startOf('month');
                  const end = moment().subtract(1, 'months').endOf('month');
                  end.set({
                    hour: 23, minute: 59, second: 59, millisecond: 0,
                  });
                  picker.$emit('pick', [start.toDate(), end.toDate()]);
                },
              },
              {
                text: 'Month-to-date',
                onClick(picker: any) {
                  const end = moment();
                  end.set({
                    hour: 23, minute: 59, second: 59, millisecond: 0,
                  });
                  end.toISOString();
                  end.format();
                  const start = moment().startOf('month');
                  picker.$emit('pick', [start.toDate(), end.toDate()]);
                },
              }],
            }],
          ],
        )


        @Emit('input')
        input(e: any) {
          return e || '';
        }

        @Emit('blur')
        blur(e: any) {
          return e;
        }

        get pickerOptions() {
          let pickerOption = this.defaultpickerOptions.get(SamclickDateRangePickerType.DATE_RANGE);
          if (this.$attrs.type) {
            pickerOption = this.defaultpickerOptions.get(this.$attrs.type);
          }

          if (this.$attrs.disableFuture === undefined || this.$attrs.disableFuture) {
            pickerOption.disabledDate = (time: any) => time.getTime() > moment();
          }

          return pickerOption;
        }

        get defaultAttrs() {
          const defaultAttrs = {
            size: 'small',
            align: 'right',
            'unlink-panels': true,
            'range-separator': 'to',
          };

          if (this.$attrs.type) {
            return Object.assign(defaultAttrs, this.defaultAttributes.get(this.$attrs.type));
          }
          return Object.assign(defaultAttrs, this.defaultAttributes.get(SamclickDateRangePickerType.DATE_RANGE));
        }

        get overrideAttrs() {
          return Object.assign(this.defaultAttrs, this.$attrs);
        }
}

export { SamclickDateRangePickerType };
export default SamclickDateRangePicker;


